import React from 'react';
import PlaylistItem from './PlaylistItem';

function Playlist({ items, title = "Live grabados", onSelectVideo }) {
  const containerStyle = {
    backgroundColor: '#1a1a1a',
    borderRadius: '12px',
    padding: '0',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #333',
    overflow: 'hidden'
  };

  const headerStyle = {
    padding: '16px 18px',
    backgroundColor: '#252525',
    borderBottom: '2px solid #D7B615',
    position: 'sticky',
    top: 0,
    zIndex: 10
  };

  const titleStyle = {
    fontWeight: 'bold',
    fontSize: '1.1em',
    color: '#D7B615',
    margin: 0,
    letterSpacing: '0.5px'
  };

  const itemsContainerStyle = {
    flexGrow: 1,
    overflowY: 'auto',
    padding: '12px',
    scrollbarWidth: 'thin',
    scrollbarColor: '#D7B615 #1a1a1a'
  };

  const emptyStateStyle = {
    textAlign: 'center',
    padding: '40px 20px',
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: '0.9em'
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h3 style={titleStyle}>{title}</h3>
      </div>
      <div style={itemsContainerStyle}>
        {items && items.length > 0 ? (
          items.map((item, index) => (
            <PlaylistItem
              key={item.id || index}
              item={item}
              onClick={() => onSelectVideo && onSelectVideo(item)}
            />
          ))
        ) : (
          <div style={emptyStateStyle}>
            No hay videos disponibles
          </div>
        )}
      </div>
    </div>
  );
}

export default Playlist; 